<template>
  <div class="modal-wrap modal-wrap--35">
    <div class="modal-header">
      <p class="mb-15 bold">Nytt bud för budgivare {{ currentUser.bidIdentity.bidder }} <br>
        <template v-if="currentUser.bidIdentity.stakeholderGroup !== null">
          <span class="fs-14 opaque-60" v-for="(stakeholder, index) in currentUser.bidIdentity.stakeholderGroup.stakeholders" v-bind:key="index">
          {{ stakeholder.customer.firstname }} {{ stakeholder.customer.lastname}}
          <i v-show="index != currentUser.bidIdentity.stakeholderGroup.stakeholders.length -1">,</i>
        </span>
        </template>
      </p>
    </div>

    <div class="modal-content">
      <div class="grid2col mb-20">
        <div>Högsta bud på objekt</div>
        <div class="text-right bold">{{ $root.formatPrice(maxBid) }} kr</div>
        <div>budgivare {{ currentUser.bidIdentity.bidder }} högsta bud</div>
        <div class="text-right">{{ $root.formatPrice(highestBidByThisBidder) }} kr</div>
      </div>

      <input type="text" inputmode="numeric" class="width-100" @input="priceFormatted(bid)" v-model="bid" placeholder="Bud">
      <div class="grid2col mt-15 mb-25">
        <div><input type="date" v-model="date" class="width-100"></div>
        <div><input type="time" v-model="time" class="width-100"></div>
      </div>
      <div class="flex align-middle mb-15">
        <label class="switch mr-10" style="width: 33px;">
          <input type="checkbox" class="mr-5" v-model="confirmedForPublish">
          <div class="slider round"></div>
        </label>
        <span class="pl-15">Godkänd för publicering</span>
      </div>
      <div class="flex align-middle">
        <label class="switch mr-10 width-50">
          <input type="checkbox" class="mr-5" v-model="bidVisibleInternet">
          <div class="slider round"></div>
        </label>
        <span class="pl-15">Detta är ett dolt bud som inte är godkänt att publicera på internet.</span>
      </div>
      <input type="text" placeholder="Budlista kommentar" v-model="bidListComment" class="mt-25 width-100">
      <input type="text" placeholder="Intern kommentar" v-model="internalComment" class="mt-15 width-100">
    </div>


    <div class="modal-buttons">
      <div class="grid2col">
        <button class="width-100 fg-black" @click="abort">
          avbryt
        </button>
        <button class="width-100" @click="save">
          spara
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'newBid',
  data() {
    return {
      date: new Date().toISOString().slice(0, 10),
      time: new Date().toLocaleTimeString().slice(0, 5),
      bidVisibleInternet: false,
      bid: '',
      bidListComment: '',
      internalComment: '',
      maxBid: this.$store.state.currentListingWithBiddings.maxBid,
      confirmedForPublish: true
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    highestBidByThisBidder() {
      return this.$root.highestValue(this.$store.state.currentUser.bidIdentity.bids, 'amount');
    }
  },
  methods: {
    priceFormatted(bid) {
      let aux = parseInt(bid.replace(/ /g, ''));
      if (aux > 0) {
        this.bid = this.$root.formatPrice(aux);
      }
    },
    abort() {
      this.$root.modalOpen = false;
    },
    save() {
      console.info("Save clicked from newBid.vue , object id:" + this.$route.params.id);
      // this.bid formatted by formatPrice so we create new
      let amount = this.bid.replace(/\s+/g, '');
      // date or time cannot be empty
      if (!this.date || !this.time) {
        alert('Datum och tid är obligatoriskt.');
        return;
      }

      // Must have bid
      if (!amount) {
        alert('Ange ett belopp.')
        return;
      }

      // Bid exceeds 50% of highest bid
      if (amount > this.maxBid * 1.5) {
        let confirm = window.confirm("Stor höjning i budgivning\n\nDet lagda budet är mer än 50% högre än nuvarande högsta bud.\nVill du lägga buden ändå?");
        if (!confirm) {
          return false;
        }
      }

      // Bid same as highest bid
      if (Number(amount) === this.maxBid) {
        let confirm = window.confirm("Det lagda budet är samma som det högsta budet.\nVill du lägga budet ändå?");
        if (!confirm) {
          return false;
        }
      }

      // Bid lower than highest bid
      if (amount < this.maxBid) {
        let confirm = window.confirm("Det lagda budet är mindre än det högsta budet.\nVill du lägga budet ändå?");
        if (!confirm) {
          return false;
        }
      }

      let objectId = this.$route.params.id;
      let bidIdentity = this.$store.state.currentUser.bidIdentity.id;
      let bidVisibleInternet = this.bidVisibleInternet ? 1 : 0;

      let data = {
        objectId : objectId,
        bidIdentity,
        amount: amount,
        hide: bidVisibleInternet,
        date: this.date + " "+ this.time + ":00",
        confirmedForPublish: this.confirmedForPublish ? 1 : 0
      };

      if (this.bidListComment) {
        data.comment = this.bidListComment;
      }
      if (this.internalComment) {
        data.commentInternal = this.internalComment;
      }

      this.$root.callFasAdApi("/internalapi/bid/create-bid-by-bid-identity/", "POST", data)
      .then((data) => {
        // reset form input
        this.bid = "";
        this.bidVisibleInternet = false;
        // close modal
        this.$root.modalOpen = false;
        // refresh data
        this.$store.dispatch('storeCurrentSelectedListing', { listingId: this.$route.params.id });
        this.$root.handleResponseMessage(data, "Nytt bud lagt för budgivare "+ this.$store.state.currentUser.bidIdentity.bidder);

        // refresh lists
        this.$store.dispatch('storeAllRecentListings');
        this.$store.dispatch('storeListingsWithActiveBiddings');

        // after new bid, show modal depending on settings
        if (this.$store.state.currentListingWithBiddings.bidSettings.bidSendAllowed > 0) {
          let deliveryType = this.$store.state.currentListingWithBiddings.bidSettings.bidSendAllowed === 1 ? 'sms' : 'email';

          let notifyThesePeople = this.$store.getters.notifyThesePeople;

          this.$store.commit('STORE_SMS_MAIL_DELIVERYWAY', deliveryType);
          this.$store.commit('STORE_SMS_MAIL_RECIEVERS', notifyThesePeople);

          // Get message template
          this.$root.callFasAdApi("/internalapi/message-template/get-bid-standard/objectId/" + this.$route.params.id)
          .then((data) => {
            if (data.status === 200) {
              this.$store.commit('STORE_SMS_MAIL_SUBJECT', data.data.subject);
              this.$store.commit('STORE_SMS_MAIL_CONTENT', data.data.content);
              this.$store.commit('STORE_SMS_MAIL_CHOSEN_MESSAGING_TEMPLATE', data.data.id);
            }
          })
          .catch(console.error);
          setTimeout(() => {
            this.$emit('submitted', { component: "sendSmsOrMail" });
          }, 1200);
        }

      })
      .catch(console.error);
    }
  }
}
</script>
